import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IFileUploadTriggerProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    Upload as UploadIcon,
    X as XIcon
} from "lucide-react-native";
import Button from "../../../button";
import Text from "../../../text";

const FileUploadTrigger: FC<IFileUploadTriggerProps> = ({
    accessibilityLabel,
    isDisabled = false,
    customLocalize,
    customTheme,
    fileName,
    onRemove,
    onPress,
    style,
    size
}) => {
    const {
        controlPaddings,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        controlPaddings,
        colors,
        spaces
    });

    return <View
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        <Button
            icon={({
                size: iconSize,
                customColor,
                color
            }) => <UploadIcon
                color={customColor ?? colors.content.icon[color]}
                size={iconSize}
            />}
            title={localize("file-upload-select-file")}
            accessibilityLabel={accessibilityLabel}
            customTheme={customTheme}
            isDisabled={isDisabled}
            spreadBehaviour="free"
            variant="outline"
            onPress={onPress}
            type="neutral"
            size={size}
        />
        <Text
            customColor={isDisabled ? colors.system.state.content.disabled.neutral : undefined}
            color={isDisabled ? undefined : "mid"}
            customTheme={customTheme}
            variant="bodyMediumSize"
            style={stylesheet.text}
            numberOfLines={1}
        >
            {fileName ?? localize("file-upload-no-file")}
        </Text>
        {
            fileName && onRemove && !isDisabled ?
                <Button
                    icon={({
                        size: iconSize,
                        customColor,
                        color
                    }) => <XIcon
                        color={customColor ?? colors.content.icon[color]}
                        size={iconSize}
                    />}
                    accessibilityLabel={localize("remove-attachment", [
                        fileName
                    ])}
                    customTheme={customTheme}
                    spreadBehaviour="free"
                    onPress={onRemove}
                    variant="ghost"
                    type="neutral"
                    size="small"
                />
            :
                null
        }
    </View>;
};
export default FileUploadTrigger;
